import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import SchemaMarkup from '../../components/feature/SchemaMarkup';

export default function SecuritySystemsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = "Güvenlik Sistemleri Kurulumu İstanbul | IP Kamera Alarm Sistemleri";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel güvenlik sistemleri kurulumu. IP kamera sistemleri, hırsız alarm, yangın alarm, geçiş kontrol sistemleri ve turnike kurulumu hizmeti.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'İstanbul, Kocaeli, Gebze, Tuzla ve Bursa\'da profesyonel güvenlik sistemleri kurulumu. IP kamera sistemleri, hırsız alarm, yangın alarm, geçiş kontrol sistemleri ve turnike kurulumu hizmeti.';
      document.head.appendChild(meta);
    }

    // Keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'güvenlik sistemleri, IP kamera kurulumu, hırsız alarm sistemi, yangın alarm sistemi, geçiş kontrol sistemi, turnike sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'keywords';
      meta.content = 'güvenlik sistemleri, IP kamera kurulumu, hırsız alarm sistemi, yangın alarm sistemi, geçiş kontrol sistemi, turnike sistemleri';
      document.head.appendChild(meta);
    }

    // Open Graph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Güvenlik Sistemleri Kurulumu İstanbul | IP Kamera Alarm Sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.content = 'Güvenlik Sistemleri Kurulumu İstanbul | IP Kamera Alarm Sistemleri';
      document.head.appendChild(meta);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Fabrika ve sanayi tesisleri için profesyonel güvenlik sistemleri. IP kamera, alarm, geçiş kontrol ve turnike sistemleri kurulumu. 7/24 destek ve 2 yıl garanti.');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:description');
      meta.content = 'Fabrika ve sanayi tesisleri için profesyonel güvenlik sistemleri. IP kamera, alarm, geçiş kontrol ve turnike sistemleri kurulumu. 7/24 destek ve 2 yıl garanti.';
      document.head.appendChild(meta);
    }

    const ogType = document.querySelector('meta[property="og:type"]');
    if (ogType) {
      ogType.setAttribute('content', 'website');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:type');
      meta.content = 'website';
      document.head.appendChild(meta);
    }

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', 'https://fiberek.com/guvenlik-sistemleri');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:url');
      meta.content = 'https://fiberek.com/guvenlik-sistemleri';
      document.head.appendChild(meta);
    }

    // Twitter Card Tags
    const twitterCard = document.querySelector('meta[name="twitter:card"]');
    if (twitterCard) {
      twitterCard.setAttribute('content', 'summary_large_image');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'twitter:card';
      meta.content = 'summary_large_image';
      document.head.appendChild(meta);
    }

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', 'Güvenlik Sistemleri Kurulumu İstanbul');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'twitter:title';
      meta.content = 'Güvenlik Sistemleri Kurulumu İstanbul';
      document.head.appendChild(meta);
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', 'IP kamera, alarm, geçiş kontrol ve turnike sistemleri kurulumu. Profesyonel güvenlik çözümleri.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'twitter:description';
      meta.content = 'IP kamera, alarm, geçiş kontrol ve turnike sistemleri kurulumu. Profesyonel güvenlik çözümleri.';
      document.head.appendChild(meta);
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://fiberek.com/guvenlik-sistemleri');
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = 'https://fiberek.com/guvenlik-sistemleri';
      document.head.appendChild(link);
    }

    // Cleanup function
    return () => {
      document.title = 'Fiber Optik Ustası';
    };
  }, []);

  const services = [
    {
      id: 1,
      title: 'IP Kamera Sistemleri',
      slug: 'ip-kamera-sistemleri',
      description: 'Yüksek çözünürlüklü IP kamera sistemleri ile 7/24 güvenlik izleme. Fabrika, sanayi tesisi ve kurumsal işletmeler için profesyonel kamera çözümleri.',
      icon: 'ri-camera-line',
      color: 'from-red-600 to-orange-600',
      features: ['4K Ultra HD Görüntü', 'Gece Görüş', 'Uzaktan İzleme', 'Hareket Algılama']
    },
    {
      id: 2,
      title: 'Hırsız Alarm Sistemleri',
      slug: 'hirsiz-alarm-sistemleri',
      description: 'Kablosuz ve kablolu hırsız alarm sistemleri kurulumu. Sanayi tesisleri, fabrikalar ve işletmeler için güvenilir alarm çözümleri.',
      icon: 'ri-alarm-warning-line',
      color: 'from-orange-600 to-amber-600',
      features: ['Kablosuz Sensörler', 'Mobil Bildirim', 'Bölgesel Kontrol', '7/24 İzleme']
    },
    {
      id: 3,
      title: 'Yangın Alarm Sistemleri',
      slug: 'yangin-alarm-sistemleri',
      description: 'TSE ve CE onaylı yangın alarm sistemleri montajı. Fabrika, sanayi tesisi ve ticari alanlar için yönetmeliğe uygun yangın algılama sistemleri.',
      icon: 'ri-fire-line',
      color: 'from-red-700 to-red-600',
      features: ['Duman Dedektörü', 'Isı Sensörü', 'Sesli Uyarı', 'Otomatik İhbar']
    },
    {
      id: 4,
      title: 'Geçiş Kontrol Sistemleri',
      slug: 'gecis-kontrol-sistemleri',
      description: 'Kartlı, şifreli ve biyometrik geçiş kontrol sistemleri. Fabrika, ofis ve sanayi tesisleri için personel takip ve güvenlik çözümleri.',
      icon: 'ri-door-lock-line',
      color: 'from-blue-600 to-cyan-600',
      features: ['Kartlı Geçiş', 'Parmak İzi', 'Yüz Tanıma', 'Zaman Takibi']
    },
    {
      id: 5,
      title: 'Bariyer Sistemleri',
      slug: 'bariyer-sistemleri',
      description: 'Otomatik bariyer sistemleri kurulumu ve bakımı. Fabrika girişleri, otopark ve sanayi tesisleri için dayanıklı bariyer çözümleri.',
      icon: 'ri-roadster-line',
      color: 'from-slate-700 to-slate-600',
      features: ['Otomatik Açılma', 'Plaka Tanıma', 'Uzaktan Kumanda', 'LED Aydınlatma']
    },
    {
      id: 6,
      title: 'Turnike Sistemleri',
      slug: 'turnike-sistemleri',
      description: 'Tripod, kanatlı ve tam boy turnike sistemleri. Fabrika, sanayi tesisi ve kurumsal işletmeler için personel giriş-çıkış kontrol sistemleri.',
      icon: 'ri-login-box-line',
      color: 'from-gray-700 to-gray-600',
      features: ['Tripod Turnike', 'Kanatlı Turnike', 'Tam Boy Turnike', 'Biyometrik Entegrasyon']
    }
  ];

  // Schema Markup Data
  const localBusinessSchema = {
    name: "Fiber Ek - Güvenlik Sistemleri",
    description: "İstanbul, Kocaeli, Gebze, Tuzla ve Bursa'da profesyonel güvenlik sistemleri kurulumu. IP kamera sistemleri, hırsız alarm, yangın alarm, geçiş kontrol sistemleri ve turnike kurulumu.",
    url: "https://fiberek.com/guvenlik-sistemleri",
    telephone: "+90 553 716 55 61",
    address: {
      locality: "İstanbul",
      region: "İstanbul",
      country: "TR"
    },
    geo: {
      latitude: "41.0082",
      longitude: "28.9784"
    },
    openingHours: ["Mo-Fr 08:00-18:00", "Sa 09:00-16:00"],
    priceRange: "$$",
    areaServed: ["İstanbul", "Kocaeli", "Gebze", "Tuzla", "Bursa", "Sakarya", "Yalova", "Tekirdağ"],
    serviceType: "Güvenlik Sistemleri Kurulumu",
    hasCredential: "TSE Onaylı Kurulum",
    sameAs: ["https://wa.me/905537165561"]
  };

  const serviceSchema = {
    name: "Güvenlik Sistemleri Kurulumu",
    description: "Fabrika, sanayi tesisi ve kurumsal işletmeler için kapsamlı güvenlik çözümleri. IP kamera, alarm, geçiş kontrol ve turnike sistemleri kurulumu.",
    provider: {
      name: "Fiber Ek",
      telephone: "+90 553 716 55 61",
      url: "https://fiberek.com",
      address: {
        locality: "İstanbul",
        region: "İstanbul", 
        country: "TR"
      }
    },
    areaServed: ["İstanbul Avrupa", "İstanbul Anadolu", "Kocaeli", "Gebze", "Tuzla", "Bursa"],
    serviceType: "Güvenlik Sistemleri",
    priceRange: "1000-50000 TRY",
    catalog: {
      name: "Güvenlik Sistemleri Hizmetleri",
      services: [
        { name: "IP Kamera Sistemleri", description: "4K Ultra HD IP kamera kurulumu ve izleme sistemleri" },
        { name: "Hırsız Alarm Sistemleri", description: "Kablosuz ve kablolu hırsız alarm sistemleri kurulumu" },
        { name: "Yangın Alarm Sistemleri", description: "TSE onaylı yangın algılama ve uyarı sistemleri" },
        { name: "Geçiş Kontrol Sistemleri", description: "Kartlı, şifreli ve biyometrik geçiş kontrol sistemleri" },
        { name: "Bariyer Sistemleri", description: "Otomatik bariyer ve plaka tanıma sistemleri" },
        { name: "Turnike Sistemleri", description: "Tripod, kanatlı ve tam boy turnike kurulumu" }
      ]
    }
  };

  const breadcrumbSchema = {
    breadcrumbs: [
      { name: "Ana Sayfa", url: "https://fiberek.com/" },
      { name: "Güvenlik Sistemleri", url: "https://fiberek.com/guvenlik-sistemleri" }
    ]
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Schema Markup Components */}
      <SchemaMarkup type="LocalBusiness" data={localBusinessSchema} />
      <SchemaMarkup type="Service" data={serviceSchema} />
      <SchemaMarkup type="BreadcrumbList" data={breadcrumbSchema} />

      <Navbar />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/9b28d6a4b2dc2668fac91d078daacc0d.jpg"
            alt="Güvenlik Sistemleri"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/90 via-slate-950/80 to-slate-950"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-600/20 border border-red-500/30 rounded-full mb-6 animate-pulse">
              <i className="ri-shield-check-line text-red-400 text-lg"></i>
              <span className="text-red-300 text-sm font-medium">Profesyonel Güvenlik Çözümleri</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              İstanbul ve Çevre İllerde
              <span className="block mt-2 bg-gradient-to-r from-red-400 via-orange-400 to-amber-400 bg-clip-text text-transparent">
                Güvenlik Sistemleri Kurulumu
              </span>
            </h1>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              IP kamera sistemleri, hırsız alarm sistemleri, yangın alarm sistemleri, geçiş kontrol sistemleri, bariyer sistemleri ve turnike sistemleri kurulumu. Fabrika, sanayi tesisi ve kurumsal işletmeler için profesyonel güvenlik çözümleri.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="group px-8 py-4 bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="group px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp Destek
              </a>
            </div>
          </div>
        </div>

        {/* Animated Background Elements */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-600/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-orange-600/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </section>

      {/* Services Grid */}
      <section className="py-20 relative">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-white mb-4">
              Güvenlik Sistemleri Hizmetlerimiz
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Sanayi tesisleri, fabrikalar ve kurumsal işletmeler için kapsamlı güvenlik çözümleri. IP kamera sistemleri, alarm sistemleri, geçiş kontrol sistemleri ve daha fazlası.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <Link
                key={service.id}
                to={`/guvenlik-sistemleri/${service.slug}`}
                className="group relative bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-8 hover:border-red-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-red-500/20 hover:-translate-y-2 cursor-pointer"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className={`w-16 h-16 flex items-center justify-center rounded-xl bg-gradient-to-br ${service.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>

                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-red-400 transition-colors">
                  {service.title}
                </h3>

                <p className="text-gray-400 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-gray-300">
                      <i className="ri-checkbox-circle-fill text-red-400"></i>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex items-center gap-2 text-red-400 font-semibold group-hover:gap-4 transition-all">
                  <span>Detaylı Bilgi</span>
                  <i className="ri-arrow-right-line text-xl"></i>
                </div>

                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-slate-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-white text-center mb-16">
              Neden Güvenlik Sistemlerimizi Tercih Etmelisiniz?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-red-600 to-orange-600 rounded-full">
                  <i className="ri-shield-check-line text-4xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">TSE Onaylı</h3>
                <p className="text-gray-400 text-sm">Tüm sistemlerimiz TSE ve CE sertifikalıdır</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-orange-600 to-amber-600 rounded-full">
                  <i className="ri-time-line text-4xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">7/24 Destek</h3>
                <p className="text-gray-400 text-sm">Kesintisiz teknik destek ve bakım hizmeti</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-blue-600 to-cyan-600 rounded-full">
                  <i className="ri-team-line text-4xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Uzman Ekip</h3>
                <p className="text-gray-400 text-sm">10+ yıl deneyimli güvenlik uzmanları</p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 bg-gradient-to-br from-slate-700 to-slate-600 rounded-full">
                  <i className="ri-tools-line text-4xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Garanti</h3>
                <p className="text-gray-400 text-sm">2 yıl garanti ve ücretsiz bakım</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 to-orange-600/20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Güvenlik Sistemi Kurulumu İçin Hemen İletişime Geçin
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              İstanbul, Kocaeli, Gebze, Tuzla, Bursa ve çevre illerde profesyonel güvenlik sistemleri kurulumu.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+905537165561"
                className="px-8 py-4 bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-red-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                +90 553 716 55 61
              </a>
              <a
                href="https://wa.me/905537165561"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-green-600 text-white rounded-lg font-semibold hover:shadow-lg hover:shadow-green-500/50 transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
